(function () {
  const CART_JSON = '/cart.js';
  const UPDATE_JSON = '/cart/update.js';

  const $ = (s, root=document) => root.querySelector(s);
  const $$ = (s, root=document) => Array.from(root.querySelectorAll(s));

  let cartCache = null;
  async function getCart(force=false){
    if(!cartCache || force){
      cartCache = fetch(CART_JSON, { headers: { Accept:'application/json' } }).then(r => r.json());
    }
    return cartCache;
  }

  let saveT = null;
  async function saveAttributes(attrs){
    clearTimeout(saveT);
    return new Promise((resolve)=>{
      saveT = setTimeout(async ()=>{
        try{
          await fetch(UPDATE_JSON, {
            method:'POST',
            headers:{ 'Content-Type':'application/json', 'Accept':'application/json' },
            body: JSON.stringify({ attributes: attrs })
          });
          await getCart(true);
        }catch(e){}
        resolve();
      }, 200);
    });
  }

  function t(gate, it, en){
    const lang = gate.getAttribute('data-lang') || 'it';
    return lang === 'en' ? en : it;
  }

  function collectAttrs(gate){
    const attrs = {};
    $$('input[name^="attributes["], select[name^="attributes["]', gate).forEach(el=>{
      const m = el.name.match(/^attributes\[(.+)\]$/);
      if(!m) return;
      if(el.type === 'checkbox') attrs[m[1]] = el.checked ? '1' : '';
      else attrs[m[1]] = (el.value || '').trim();
    });
    return attrs;
  }

  function fillFromCart(gate, cart){
    const a = cart.attributes || {};
    $$('input[name^="attributes["], select[name^="attributes["]', gate).forEach(el=>{
      const m = el.name.match(/^attributes\[(.+)\]$/);
      if(!m) return;
      const key = m[1];
      const v = (a[key] ?? '');
      if(el.type === 'checkbox') el.checked = String(v) === '1';
      else if(v !== '' && el.value !== v) el.value = v;
    });

    const itType = $('[data-mb-it-type]', gate);
    if(itType && !itType.value) itType.value = 'privato';
  }

  function findCheckoutTargets(scope=document){
    const btns = [
      ...$$('button[name="checkout"], input[name="checkout"]', scope),
      ...$$('button[formaction^="/checkout"], input[formaction^="/checkout"]', scope),
      ...$$('[data-checkout], [data-action="checkout"]', scope).filter(el => el.tagName !== 'A')
    ];

    const links = [
      ...$$('a[href^="/checkout"]', scope),
      ...$$('a[href*="/checkout"]', scope),
      ...$$('[data-checkout], [data-action="checkout"]', scope).filter(el => el.tagName === 'A')
    ];

    const dynamic = $$('.shopify-payment-button, .additional-checkout-buttons, .cart__dynamic-checkout-buttons', scope);

    return { btns: Array.from(new Set(btns)), links: Array.from(new Set(links)), dynamic };
  }

  function lockTargets(targets, lock){
    targets.btns.forEach(b=>{
      if (b.disabled !== !!lock) b.disabled = !!lock;
      b.setAttribute('aria-disabled', lock ? 'true' : 'false');
    });

    targets.links.forEach(a=>{
      const has = a.classList.contains('mb-checkout-disabled');
      if(lock && !has){
        a.classList.add('mb-checkout-disabled');
        a.setAttribute('aria-disabled','true');
      }
      if(!lock && has){
        a.classList.remove('mb-checkout-disabled');
        a.removeAttribute('aria-disabled');
      }
    });

    // nascondi sempre express checkout (così non bypassano il gate)
    targets.dynamic.forEach(d=>{
      if (d.style.display !== 'none') d.style.display = 'none';
    });
  }

  function setModeAndRequired(gate){
    const nonRes = $('[data-mb-nonres]', gate);
    const itType = $('[data-mb-it-type]', gate);

    const cf = $('[data-mb-cf]', gate);
    const company = $('[data-mb-company]', gate);
    const vat = $('[data-mb-vat]', gate);
    const sdi = $('[data-mb-sdi]', gate);

    const nonResident = !!(nonRes && nonRes.checked);
    const type = itType ? itType.value : 'privato';
    const isAzienda = (!nonResident && type === 'azienda');

    gate.classList.toggle('mb-mode-nonresident', nonResident);
    gate.classList.toggle('mb-mode-azienda', !nonResident && isAzienda);
    gate.classList.toggle('mb-mode-privato', !nonResident && !isAzienda);

    // reset required
    if(itType) itType.required = false;
    if(cf) cf.required = false;
    if(company) company.required = false;
    if(vat) vat.required = false;
    if(sdi) sdi.required = false;

    if(nonResident) return { nonResident:true, type:null };

    if(itType) itType.required = true;

    if(isAzienda){
      if(company) company.required = true;
      if(vat) vat.required = true;
      if(sdi) sdi.required = true;
      return { nonResident:false, type:'azienda' };
    } else {
      if(cf) cf.required = true;
      return { nonResident:false, type:'privato' };
    }
  }

  function validate(gate){
    const msgEl = $('[data-mb-msg]', gate);
    const s = setModeAndRequired(gate);

    if(s.nonResident){
      if(msgEl) msgEl.textContent = '';
      return { ok:true, msg:'' };
    }

    const val = (key) => (gate.querySelector(`[name="attributes[${key}]"]`)?.value || '').trim();

    if(s.type === 'privato'){
      if(!val('mb_codice_fiscale')){
        return { ok:false, msg: t(gate,'Inserisci il Codice Fiscale.','Enter the tax code (Codice Fiscale).') };
      }
    } else {
      if(!val('mb_company_name')) return { ok:false, msg: t(gate,'Inserisci la Ragione Sociale.','Enter the company name.') };
      if(!val('mb_partita_iva'))  return { ok:false, msg: t(gate,'Inserisci la Partita IVA.','Enter the VAT number.') };
      if(!val('mb_sdi'))          return { ok:false, msg: t(gate,'Inserisci lo SDI.','Enter the SDI.') };
    }

    if(msgEl) msgEl.textContent = '';
    return { ok:true, msg:'' };
  }

  function bindClicksOnce(gate, handler){
    const targets = findCheckoutTargets(document);

    targets.links.forEach(a=>{
      if(a.__mbBound) return;
      a.__mbBound = true;
      a.addEventListener('click', handler, true);
    });

    targets.btns.forEach(b=>{
      if(b.__mbBound) return;
      b.__mbBound = true;
      b.addEventListener('click', handler, true);
    });
  }

  async function initGate(gate){
    const threshold = parseInt(gate.getAttribute('data-threshold') || '0', 10);
    const always = gate.getAttribute('data-always') === '1';

    const cart = await getCart();
    const active = always || (cart.total_price >= threshold);

    if(!active){
      gate.style.display = 'none';
      lockTargets(findCheckoutTargets(document), false);
      return;
    }

    gate.style.display = '';
    fillFromCart(gate, cart);

    const apply = (save=false) => {
      const v = validate(gate);
      lockTargets(findCheckoutTargets(document), !v.ok);
      const msgEl = $('[data-mb-msg]', gate);
      if(msgEl) msgEl.textContent = v.ok ? '' : v.msg;
      if(save) saveAttributes(collectAttrs(gate));
      return v.ok;
    };

    // lock immediato, poi rinforzo leggero (senza observer globale)
    apply(false);
    setTimeout(()=>apply(false), 120);
    setTimeout(()=>apply(false), 500);

    gate.addEventListener('input', ()=>apply(true));
    gate.addEventListener('change', ()=>apply(true));

    const blockIfInvalid = async (e)=>{
      const ok = apply(true);
      if(!ok){
        e.preventDefault();
        gate.scrollIntoView({ behavior:'smooth', block:'start' });
      }
    };

    bindClicksOnce(gate, blockIfInvalid);

    // observer SAFE: solo per ri-bindare quando il drawer ricrea i CTA
    let obsT = null;
    const obs = new MutationObserver((mutations)=>{
      // se non sono stati aggiunti nodi, ignora
      if(!mutations.some(m => m.addedNodes && m.addedNodes.length)) return;

      clearTimeout(obsT);
      obsT = setTimeout(()=>{
        // disconnect mentre applichi per evitare loop
        obs.disconnect();
        bindClicksOnce(gate, blockIfInvalid);
        apply(false);
        obs.observe(document.documentElement, { childList:true, subtree:true });
      }, 80);
    });
    obs.observe(document.documentElement, { childList:true, subtree:true });
  }

  function boot(){
    $$('[data-mb-tax-gate]').forEach(g=>{
      if(g.__mbInited) return;
      g.__mbInited = true;
      initGate(g);
    });
  }

  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
